import React from "react";
import { RadioGroup as BaseRadioGroup } from "../../ui/radio-group";
import { cn } from "../../utils";
import { RadioGroupProps } from "./types";

export const RadioGroup = React.forwardRef<
  React.ComponentRef<typeof BaseRadioGroup>,
  RadioGroupProps
>((props, ref) => {
  const {
    value,
    defaultValue,
    onValueChange: propsOnValueChange,
    disabled = false,
    readOnly = false,
    className: propsClassName,
    direction = "horizontal",
    dir = "ltr",
    name,
    onChange,
    ...rest
  } = props;

  const onValueChange = (next: string) => {
    if (readOnly) {
      return;
    }
    // Create a synthetic event to match the signature of a regular input change event
    onChange?.({
      target: { value: next },
    } as React.ChangeEvent<HTMLInputElement>);
    // Forward to both react-hook-form and Radix's onValueChange
    propsOnValueChange?.(next);
  };

  const radioGroupClassName = cn(
    "qodo qodo-custom-radio-group",
    "flex",
    {
      "flex-row gap-6": direction === "horizontal",
      "flex-col gap-3": direction === "vertical",
    },
    propsClassName,
  );

  return (
    <BaseRadioGroup
      name={name}
      ref={ref}
      value={value}
      defaultValue={defaultValue}
      onValueChange={onValueChange}
      disabled={disabled || readOnly}
      readOnly={readOnly}
      className={radioGroupClassName}
      dir={dir as "ltr" | "rtl"}
      {...rest}
    />
  );
});

RadioGroup.displayName = "BaseRadioGroupComponent";
